import React from 'react';

interface LazyImageProps {
    src: string,
    alt?: string,
    className?: string,
    width?: number,
    height?: number,
}

const LazyImage: React.FC<LazyImageProps> = ({src, alt, className, width, height}) => {
    return <img loading="lazy" src={src} alt={alt} className={className}/>;
};

export default LazyImage;
